module.exports = __webpack_public_path__ + "img/img_about_1.c7a5a976.png";